import { PageHeader } from 'src/components';

export function MembersPage() {
  return (
    <section className="flex flex-col max-w-right-section mx-auto px-6 xl:px-0">
      <PageHeader
        title="Members"
        description="Oversee team administration by adding, removing, and assigning roles to users."
      />
    </section>
  );
}
